module.exports = __webpack_public_path__ + "img/falcon_blade.0afb1bed.png";